module.exports = __webpack_public_path__ + "media/images/favicon/android-chrome-192x192-675069c40f3734964a7f56ffbd299583.png";